var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"routerview"},[_c('router-view',_vm._b({},'router-view',{ entryId: _vm.entryId },false))],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }